import BaseAPI from './base.api.service'

const resource = 'GroundTransportations';
export default {
    async getGroundTransportation(erID) {
        return await BaseAPI.get(`expensereports/${erID}/GroundTransportation`);
    },
    async getGroundTransportationTypes() {
        return await BaseAPI.get(`${resource}/Types`);
    },
    async getMileageRates() {
        return await BaseAPI.get(`${resource}/mileagerates`);
    }
} 